module.exports = __webpack_public_path__ + "static/img/7.d94e6286.jpg";